(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDetailController', VideoInformativoDetailController);

    VideoInformativoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'VideoInformativo'];

    function VideoInformativoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:videoInformativoUpdate', function(event, result) {
            vm.videoInformativo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
